import { Component, Input, OnInit } from '@angular/core';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss'],
})
export class ErrorMessageComponent implements OnInit {

  @Input() error: Error;
  @Input() autoHide: boolean = false;
  @Input() autoHideTimeout: number = 0;

  show: boolean = true;

  constructor(
    public readonly globalErrorHandler: GlobalErrorHandlerService
  ){
  }

  ngOnInit() {
    if (!!this.autoHide) {
      setTimeout(() => {
        this.show = false;
      }, this.autoHideTimeout);
    }
  }

}
